function isDict (v) {
  /**
   * Проверяет, является ли значение объектом
   * @param {any} v - значение для проверки
   * @returns {boolean} true, если значение является объектом, иначе false
   */
  return typeof v === 'object' && v !== null && !(v instanceof Array) && !(v instanceof Date)
}

export default {
  data () {
    return {
      errors: {
        fields: [],
        non: []
      },
      scrolled: false
    }
  },
  methods: {
    setNotScrolled: function () {
      /**
       * Отключает скролл на странице
       */
      this.scrolled = false
    },
    setScrolled: function () {
      /**
       * Включает скролл на странице
       */
      this.scrolled = true
    },
    mapErrors: function (data) {
      /**
       * Обрабатывает ошибки из ответа сервера
       * @param {Object} data - объект с ошибками от сервера
       */
      if ('non_field_errors' in data) { this.addNonFieldError(data.non_field_errors) }
      this.setNotScrolled()
      this.errors.fields = data
    },
    hasError: function (field, errors = undefined) {
      /**
       * Проверяет наличие ошибки в указанном поле
       * @param {string} field - имя поля для проверки
       * @param {Object} errors - объект с ошибками
       * @returns {boolean} true, если ошибка есть, иначе false
       */
      const result = this.getError(field) !== ''
      if (result && !this.scrolled) {
        if (this.$refs[field]) {
          this.setScrolled()
          let ref = this.$refs[field]
          if (Array.isArray(this.$refs[field])) { ref = ref[0] }
          ref.$el.scrollIntoView()
        }
      }
      return result
    },
    getError: function (field, errors = undefined) {
      /**
       * Получает текст ошибки для указанного поля
       * @param {string} field - имя поля
       * @param {Object} errors - объект с ошибками (по умолчанию используется this.errors.fields)
       * @returns {string} текст ошибки или пустая строка, если ошибки нет
       */
      if (errors === undefined) { errors = this.errors.fields }
      for (const val in errors) {
        if (isDict(errors[val])) {
          if (field !== undefined && field !== null && field.includes('.')) {
            return this.getError(field.split('.').slice(1).join('.'), errors[val])
          }
        }
        if ((errors[val]).length > 0) {
          if (val === field) { return errors[val] }
        }
      }
      return ''
    },
    deleteError: function (field, id = undefined) {
      /**
       * Удаляет ошибку для указанного поля
       * @param {string} field - имя поля
       * @param {string} id - дополнительный идентификатор для вложенных ошибок
       */
      delete this.errors.fields[field]
      if (id !== undefined) {
        this.$delete(this.errors.fields[id], field)
        if (Object.keys(this.errors.fields[id]).length === 0) {
          this.$delete(this.errors.fields, id)
        }
      } else {
        delete this.errors.fields[field]
      }
    },
    deleteNonFieldError: function (error) {
      /**
       * Удаляет ошибку без привязки к полю
       * @param {string} error - текст ошибки для удаления
       */
      const errors = this.errors.non
      errors.splice(errors.indexOf(error), 1)
      this.$set(this.errors, 'non', errors)
    },
    addNonFieldError: function (error) {
      /**
       * Добавляет ошибку без привязки к полю
       * @param {string} error - текст ошибки для добавления
       */
      const errors = this.errors.non
      if (errors.indexOf(error)) { errors.push(error) }
      this.$set(this.errors, 'non', errors)
      // this.show_non_field_errors = true;
    },
    getNonFieldErrors: function () {
      /**
       * Получает все ошибки без привязки к полям
       * @returns {Array} массив ошибок без привязки к полям
       */
      return this.errors.non
    }
  }
}
